import React, { use, useEffect } from 'react';
import usePageTitle from '../../utils/usePageTitle';
import { Layout, Menu, theme } from 'antd';
import '../../style/component.css'
import Headers from '../header/Header';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/authContext';
import ParentSidebarMenu from '../sidebar/ParentSidebarMenu';
import { fetchProfile } from '../../service/api';

const { Content, } = Layout;


const ParentLayout = () => {
    const { token, getCurrentUser, user } = useAuth()

    usePageTitle("Parent")

    const showProfile = async () => {
        try {
            const res = await fetchProfile()
            console.log("fetch parent ", res)
            if (res.status === 200) {
                getCurrentUser(res.data.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        showProfile()
    }, [])

    // if (!token) {
    //     return <Navigate replace to="/login" />
    // } else {

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Headers />
            <Layout>
                <ParentSidebarMenu />
                <Layout className='main'>
                    <Content className='content'>
                        <Outlet />
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );

};



export default ParentLayout